export const STAIR_COMPONENT_LANDING = "Landing";
export const STAIR_COMPONENT_RISER = "Riser";
export const STAIR_COMPONENT_RUN_LANDING = "Run_Landing";
export const STAIR_COMPONENT_SIDE = "Side";
export const STAIR_COMPONENT_STAIR_BODY = "Stair_Body";
export const STAIR_COMPONENT_STRINGER = "Stringer";
export const STAIR_COMPONENT_TREAD = "Tread";
export const STAIR_COMPONENT_UNDERSIDE = "Underside";
